import { lazy } from 'react'

export const UpsellPaywallV1 = lazy(() => import('./v1/UpsellPaywallV1'))
export const UpsellPaywallV2 = lazy(() => import('./v2/UpsellPaywallV2'))
export const UpsellPaywallV3 = lazy(() => import('./v3/UpsellPaywallV3'))
export const UpsellPaywallV4 = lazy(() => import('./v4/UpsellPaywallV4'))
export const UpsellPaywallV5 = lazy(() => import('./v5/UpsellPaywallV5'))
export const UpsellPaywallV6 = lazy(() => import('./v6/UpsellPaywallV6'))
